<div class="main-container">
    <mat-toolbar *ngIf="currentUser" color="primary">
        <mat-toolbar-row>
            <h4 class="title-font">DeckPlan</h4>

            <button mat-button [matMenuTriggerFor]="dashboardSubMenu">Dashboard</button>
            <mat-menu #dashboardSubMenu="matMenu">
                <button mat-menu-item (click)="goToHome()">Home</button>
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="decksSubMenu">Decks</button>
            <mat-menu #decksSubMenu="matMenu">
                <button mat-menu-item (click)="goToDecks()">My Decks</button>
                <button mat-menu-item (click)="goToPublicDecks()">Public Decks</button>
            </mat-menu>
            <button mat-button (click)="goToInventory()">Inventory</button>
            <button mat-button [matMenuTriggerFor]="adminSubMenu" *ngIf="currentUser.isAdmin">Admin</button>
            <mat-menu #adminSubMenu="matMenu">
                <button mat-menu-item (click)="goToAdminDashboard()">Dashboard</button>
            </mat-menu>

            <span class="spacer"></span>
            <button mat-icon-button (click)="openCardSearch()">
                <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="accountMenu">
                <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #accountMenu="matMenu">
                <button (click)="goToProfile()" mat-menu-item>
                    <mat-icon>account_circle</mat-icon>
                    <span>Account</span>
                </button>
                <mat-divider></mat-divider>
                <button (click)="logout()" mat-menu-item>
                    <mat-icon>power_settings_new</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
            <button [matMenuTriggerFor]="menu" aria-label="Settings" mat-icon-button>
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item [matMenuTriggerFor]="themes">
                    <mat-icon>palette</mat-icon>
                    <span>Themes</span>
                </button>
            </mat-menu>
            <mat-menu #themes="matMenu">
                <button mat-menu-item (click)="switchTheme('blue-grey-theme')" gtagEvent trackOn="click" action="light_theme" category="ui">Blue Grey Theme</button>
                <button mat-menu-item (click)="switchTheme('blue-grey-theme-dark')" gtagEvent trackOn="click" action="dark_theme" category="ui">Dark Blue Grey Theme</button>
            </mat-menu>
        </mat-toolbar-row>
        <mat-toolbar-row class="breadcrumb">
            <app-breadcrumb></app-breadcrumb>
        </mat-toolbar-row>
        <mat-toolbar-row *ngIf="bannersRetrieved > 0">
            <app-banner-bar class="full-width" (bannersRetrievedCount)="bannersRetrieved = $event"></app-banner-bar>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-sidenav-container>
        <mat-sidenav mode="side" opened="false">Sidenav content</mat-sidenav>
        <mat-sidenav-content cdkDropListGroup>
            <div class="main">
                <router-outlet></router-outlet>
            </div>
            <footer class="primary-background">
                <ul>
                    <li>
                        <a href="https://reddit.com/r/deckplan" target="_blank" gtagEvent trackOn="click" action="reddit_link" category="community"><i class="fab fa-reddit"></i></a>&nbsp;
                        <a href="https://twitter.com/deckplan_io" target="_blank" gtagEvent trackOn="click" action="twitter_link" category="community"><i class="fab fa-twitter"></i></a>&nbsp;
                        <a *ngIf="authService.currentUserValue && authService.currentUserValue.subscriptionStatus === 'active'" href="https://discord.gg/YyS8H5KxXp" target="_blank" gtagEvent trackOn="click" action="discord_link" category="community"><i class="fab fa-discord"></i></a>
                    </li>
                    <li><a href="/contact" gtagEvent trackOn="click" action="contact_us_from_footer" category="community">Contact Us</a></li>
                    <li><a href="/privacy" gtagEvent trackOn="click" action="privacy_from_footer" category="legal">Privacy Policy</a></li>
                    <li><a href="/terms" gtagEvent trackOn="click" action="terms_from_footer" category="legal">Terms and Conditions</a></li>
                </ul>
                <div class="disclaimer">
                    Wizards of the Coast, Magic: The Gathering, and their logos are trademarks of Wizards of the Coast LLC in the United States and other countries. © 1993-2020 Wizards. All Rights Reserved.<br><br>
                    Spartan Coding LLC is not affiliated with, endorsed, sponsored, or specifically approved by Wizards of the Coast LLC. Spartan Coding LLC may use the trademarks and other intellectual property of Wizards of the Coast LLC, which is permitted under Wizards' Fan Site Policy. All Wizards of the Coast intellectual property used by Spartan Coding LLC can be accessed via the search icon for FREE. MAGIC: THE GATHERING® is a trademark of Wizards of the Coast. For more information about Wizards of the Coast or any of Wizards' trademarks or other intellectual property, please visit their website at <a href="https://company.wizards.com/"  gtagEvent trackOn="click" action="wizards_from_footer" category="legal">https://company.wizards.com/</a>.<br><br>
                    Card data (including any pricing information) is provided by <a href="https://scryfall.com"  gtagEvent trackOn="click" action="scryfall" category="legal">Scryfall</a>. They make no guarantee of its accuracy and recommend that you see stores for final prices and details.
                </div>
                <em class="powered-by">Version {{version}} Powered by <span class="orbitron">Spartan Coding LLC</span></em>
            </footer>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
